<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> متقاضی سرویس مدرسه  </span>

    </div>

</div>

<div dir="rtl" class="form w-100 row gx-2 px-2 ">

    <div class="col-12 col-md-4">

        <label> نام مدرسه </label>

        <input type="search" class="form-control" #school [placeholder]="school.value == '' && list_Schools.length == 0 ? 'لطفا اندکی صبر کنید' : '' "  autocomplete="off" [(ngModel)]="searchT_School" (input)="filterSchool()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredSchools" (click)="selectedSchool(item)" [@fadeAnimation]>{{ item.strComment }} </li>

        </ul>

    </div>

    <div class="col-12 col-md-4">

        <label for="tiSex"> وضعیت </label>

        <select required [(ngModel)]="tiServiceRequestStatus" name="tiServiceRequestStatus" class="form-control">

            <option *ngFor="let item of list_Status" [value]="item.tiServiceRequestStatus" > {{item.strComment}} </option>

        </select>

    </div>

    <div class="col-12 col-md-4 d-flex align-items-end  justify-content-end ">

        <button class="btn mx-md-2 mt-2 mt-md-0 px-5 btn-primary w-50" type="button" (click)="searchApplicant_Service()" >جستجو</button>

    </div>

    <main class=" rtl px-2 mt-2 p-2">

        <span class="px-2" *ngIf="list_Applicant.length > 0"> تعداد  <span class="text-danger fw-bold ">{{list_Applicant.length | faNum}}</span>  مورد یافت شد </span>

        <div class="row gx-2 mt-2 border border-2 p-2">

            <div class="col-12  mt-3 mb-4">
    
                <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">
    
            </div>

            <div class="section table-responsive" style="max-height: 68vh;">

                <table class="table table-striped" id="Export_Excel">
        
                    <thead class="position-sticky top-0 bg-white">
        
                        <tr class="col-12 text-center">

                            <th> # </th>

                            <th> عملیات </th>

                            <th> تاریخ ثبت </th>

                            <th> مدرسه </th>

                            <th> نام و نام خانوادگی </th>

                            <th> جنسیت </th>

                            <th> آدرس </th>

                            <th> موبایل </th>

                            <th> فاصله تا مدرسه </th>

                            <th> وضعیت </th>

                        </tr>
        
                    </thead>
        
                    <tbody>
        
                        <tr class="col-12 text-center" *ngFor="let item of list_Applicant;let i = index">
        
                            <th> {{ i + 1 | faNum }} </th>
        
                            <td class="col-1">
    
                                <i class="fa fa-pencil-square-o fa-lg px-3 btn btn-primary" title="ویرابش"  (click)="showDetail(item,true,i)"></i>
    
                                <i class="fa fa-info-circle fa-lg px-3 my-2 mx-2 btn btn-dark" title="جرئیات" (click)="showDetail(item,false)"></i>
    
                            </td>

                            <td>{{item.strFullDate | faNum}}</td>

                            <td>{{item.strMobileDomain_strComment | faNum}}</td>

                            <td>{{item.strPassenger_FullName | faNum}}</td>

                            <td>{{item.strSex_strSexComment | faNum}}</td>

                            <td style="max-width: 330px;text-wrap: wrap;">{{item.strAddress | faNum}}</td>

                            <td>{{item.strMobile | faNum}}</td>

                            <td>{{item.fDistance + ' کیلومتر ' | faNum}}</td>

                            <td>{{getStr_Status(item.tiServiceRequestStatus)}}</td>
          
                        </tr>
        
                    </tbody>
        
                </table>
        
            </div>

        </div>

    </main>

</div>

<div class="modal fade" id="detailModal" tabindex="-1" aria-labelledby="" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{editMode ? ' ویرایش ' : 'جزئیات دانش آموز' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="text-center">

                <img class="rounded-circle" width="150" height="150" src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}" alt="">

              </div>

            <div dir="rtl" class="row p-2 gx-2 gy-2">

                <div class="col-12 col-md-4">

                    <label>نام</label>

                    <input type="text" [ngModel]="studentData?.strName" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>نام خانوادگی</label>

                    <input type="text" [ngModel]="studentData?.strFamily" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>جنسیت</label>

                    <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>شماره موبایل</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.strMobile | faNum )" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> کد ملی </label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.strNationalCode | faNum)" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label>مدرسه</label>

                    <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">

                </div>

                <div class="col-12 col-md-4 position-relative">

                    <label>فاصله تا مدرسه</label>

                    <input type="text" [ngModel]="( studentData?.fDistance| faNum ) + ' کیلومتر' " class="form-control">

                    <button *ngIf="editMode" class="mx-2 btn btn-success calc-button rounded position-absolute" (click)="calcDistance(studentData.iMobileDomain)">

                        <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

                <div class="col-12 col-md-4">

                    <label> تاریخ ثبت </label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.strFullDate| faNum )" class="form-control">

                </div>

                <div class="col-12 col-md-4">

                    <label> وضعیت </label>

                    <select *ngIf="studentData" required [(ngModel)]="studentData.tiServiceRequestStatus" [ngClass]="editMode ? '' : 'x' " name="tiServiceRequestStatus" class="form-control">

                        <option *ngFor="let item of list_Status" [value]="item.tiServiceRequestStatus" > {{item.strComment}} </option>
            
                    </select>

                </div>

                <div class="col-12 position-relative">

                    <label> آدرس </label>

                    <input type="text" [ngModel]="studentData?.strAddress" class="form-control">

                    <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button" (click)="showOnMap()">

                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

               <div class="col-md-6 col-6">

                    <label>طول جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.fOriginLon | faNum )" class="form-control">

                </div>

                <div class="col-md-6 col-6">

                    <label>عرض جغرافیایی</label>

                    <input dir="ltr" type="text" [ngModel]="( studentData?.fOrigiLat| faNum )" class="form-control">

                </div>

                <div class="col-12">

                    <label> توضیحات </label>

                    <textarea *ngIf="studentData" [ngClass]="editMode ? '' : 'x' " [(ngModel)]="studentData.strComment" cols="30" rows="10" class="form-control"></textarea>

                </div>

            </div>

            <div class="modal-footer row gx-0 w-100">
    
                <button *ngIf="editMode" class="col-12 col-md-auto btn btn-success" type="button" 
                
                    (click)="costCalculate()" > 

                    محاسبه هزینه سرویس
        
                </button>

                <button *ngIf="editMode" class="col-12 col-md-auto btn btn-primary" type="button" 
                
                    (click)="editApplicant()" > 

                    &nbsp; ویرایش &nbsp;
        
                </button>
            
            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="stdLocation" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>